import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/base/SEOHead';

const PubPage = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "BarOrPub",
    "name": "The Ocean View Sports Pub",
    "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/pub`,
    "image": "https://theocean-view.com/wp-content/uploads/2023/10/qtq80-M8xK7L.jpeg",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "84500 Overseas Hwy",
      "addressLocality": "Islamorada",
      "addressRegion": "FL",
      "postalCode": "33036",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 24.9470979,
      "longitude": -80.6019239
    },
    "telephone": "(305) 664-8052",
    "email": "resinfo@theocean-view.com",
    "sameAs": [
      "https://www.facebook.com/The-OceanView-Motel-and-Sports-Pub-176655585715394",
      "https://www.instagram.com/oceanview_inn_pub/"
    ],
    "servesCuisine": ["American", "Seafood", "Bar Food"],
    "priceRange": "$$",
    "currenciesAccepted": "USD",
    "paymentAccepted": "Cash, Credit Card, Debit Card",
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday"],
        "opens": "11:00",
        "closes": "22:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Friday", "Saturday"],
        "opens": "11:00",
        "closes": "01:00"
      }
    ],
    "hasMenu": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/menu`,
    "acceptsReservations": true,
    "amenityFeature": [
      {
        "@type": "LocationFeatureSpecification",
        "name": "Waterfront Seating",
        "value": true
      },
      {
        "@type": "LocationFeatureSpecification",
        "name": "Boat Dock Access",
        "value": true
      },
      {
        "@type": "LocationFeatureSpecification",
        "name": "Live Music",
        "value": true
      },
      {
        "@type": "LocationFeatureSpecification",
        "name": "Sports Viewing",
        "value": true
      }
    ]
  };

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Bar & Pub in Islamorada | The Ocean View Sports Pub with Waterfront Dock Access"
        description="The Ocean View Sports Pub is the best bar and pub in Islamorada, Florida Keys. Our waterfront sports bar features boat dock access, live music, sports viewing on big screens, fresh seafood, American bar food, craft beers, and signature cocktails. Located on the Overseas Highway with direct water access for boaters. Open late on weekends - your favorite Islamorada pub for locals and visitors!"
        keywords="bar in Islamorada, pub in Islamorada, Islamorada bar, sports pub Islamorada, Florida Keys bar, waterfront bar, boat dock bar, Islamorada sports bar"
        canonical={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/pub`}
        ogTitle="Best Bar & Pub in Islamorada FL | The Ocean View Sports Pub"
        ogDescription="Islamorada's favorite waterfront sports pub and bar with boat dock access, live music, sports viewing, and great food in the Florida Keys."
        ogImage="https://theocean-view.com/wp-content/uploads/2023/10/qtq80-M8xK7L.jpeg"
        ogUrl={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/pub`}
        structuredData={structuredData}
        geoPosition="24.9470979;-80.6019239"
        geoRegion="US-FL"
        geoPlacename="Islamorada, Florida"
      />
      <Header />
      <main className="pt-20">
        <section className="relative h-[400px] flex items-center justify-center overflow-hidden">
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage: 'url(https://theocean-view.com/wp-content/uploads/2016/03/phoca_thumb_l_ov74.jpg)',
            }}
          >
            <div className="absolute inset-0 bg-slate-900/60"></div>
          </div>
          <div className="relative z-10 text-center text-white max-w-4xl mx-auto px-4">
            <h1 className="text-5xl md:text-6xl font-bold mb-4 font-serif">The Sports Pub</h1>
            <p className="text-xl text-slate-200">
              Islamorada's favorite waterfront bar and pub with boat dock access, fresh seafood, cold drinks, and authentic Keys atmosphere
            </p>
          </div>
        </section>

        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-3xl mx-auto text-center mb-16">
              <h2 className="text-4xl font-bold text-slate-900 mb-6 font-serif">
                A Local Favorite Bar & Pub Since 1996
              </h2>
              <p className="text-lg text-slate-600 leading-relaxed">
                In January 2003, the final phase of the makeover was completed with the addition of a beautiful new swimming pool. The Pub was in line for a complete makeover, including some great new additions while keeping the flavor of the old Keys. A new kitchen was added, and the Pub is now a favorite eatery, sports bar, and watering hole for both tourists and locals alike. Our waterfront location offers boat dock access for visitors arriving by water.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
              <div className="rounded-2xl overflow-hidden shadow-xl">
                <img
                  src="https://static.readdy.ai/image/a0544820e0625081891e0a711cac5596/66d23442c62f192816ceb8030448db15.jpeg"
                  alt="Ocean View Sports Pub conch fritters appetizer"
                  className="w-full h-64 object-cover"
                />
              </div>
              <div className="rounded-2xl overflow-hidden shadow-xl">
                <img
                  src="https://static.readdy.ai/image/a0544820e0625081891e0a711cac5596/40e1c930337bd7c6b1c4b4d8fa9b3f27.jpeg"
                  alt="Delicious burger and fries at Islamorada bar"
                  className="w-full h-64 object-cover"
                />
              </div>
              <div className="rounded-2xl overflow-hidden shadow-xl">
                <img
                  src="https://theocean-view.com/wp-content/uploads/2016/03/phoca_thumb_l_dsc_0528.jpg"
                  alt="Ocean View waterfront pool area with dock access"
                  className="w-full h-64 object-cover"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
              <div>
                <h3 className="text-3xl font-bold text-slate-900 mb-6">What Our Bar & Pub Offers</h3>
                <div className="space-y-6">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-restaurant-2-line text-2xl text-blue-600"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-slate-900 mb-2">Fresh Food</h4>
                      <p className="text-slate-600">Homemade steak, seafood, burgers, wings, sandwiches, wraps, and game day appetizers</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-beer-line text-2xl text-blue-600"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-slate-900 mb-2">Full Bar</h4>
                      <p className="text-slate-600">Craft beers, signature cocktails, and your favorite spirits at our Islamorada bar</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-tv-2-line text-2xl text-blue-600"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-slate-900 mb-2">Sports Viewing</h4>
                      <p className="text-slate-600">Multiple large screens for all major sporting events at our sports pub</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-anchor-line text-2xl text-blue-600"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-slate-900 mb-2">Boat Dock Access</h4>
                      <p className="text-slate-600">Direct water access for boaters - dock your boat and enjoy our waterfront pub</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-sun-line text-2xl text-blue-600"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-slate-900 mb-2">Outdoor Patio</h4>
                      <p className="text-slate-600">Enjoy your meal with ocean breezes and tropical atmosphere</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-music-2-line text-2xl text-blue-600"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-slate-900 mb-2">Live Entertainment</h4>
                      <p className="text-slate-600">Weekly jam nights and live music performances at our pub</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-2xl p-8 text-white">
                <h3 className="text-3xl font-bold mb-6">Bar Hours of Operation</h3>
                <div className="space-y-4">
                  <div className="flex justify-between items-center pb-3 border-b border-slate-700">
                    <span className="font-medium">Sunday - Thursday</span>
                    <span className="text-slate-300">11:00 AM - 10:00 PM</span>
                  </div>
                  <div className="flex justify-between items-center pb-3 border-b border-slate-700">
                    <span className="font-medium">Friday - Saturday</span>
                    <span className="text-slate-300">11:00 AM - 1:00 AM</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl p-8 md:p-12 text-center">
              <h3 className="text-3xl font-bold text-slate-900 mb-4">Visit Our Bar & Pub Today</h3>
              <p className="text-lg text-slate-600 mb-8 max-w-2xl mx-auto">
                Join us for lunch, dinner, or just drinks at the best bar and pub in Islamorada. Arrive by car or boat - we welcome all visitors to our waterfront sports pub in the Florida Keys!
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a
                  href="https://www.toasttab.com/the-ocean-view-84500-overseas-hwy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-blue-600 to-cyan-500 text-white rounded-lg font-semibold text-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 whitespace-nowrap"
                >
                  <i className="ri-shopping-bag-line mr-2"></i>
                  Order Online
                </a>
                <a
                  href="tel:+13056648052"
                  className="inline-flex items-center justify-center px-8 py-4 bg-white text-slate-900 rounded-lg font-semibold text-lg border-2 border-slate-200 hover:border-blue-600 hover:text-blue-600 transition-all duration-300 whitespace-nowrap"
                >
                  <i className="ri-phone-line mr-2"></i>
                  Call (305) 664-8052
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default PubPage;
